export default __webpack_public_path__ + "static/media/notify.3ebd75ea.mp3";